
(function () {
    'use strict';
    var controllerId = 'purchaseOrderItemsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', 'NgTableParams','$filter', purchaseOrderItemListCtrl]);

    function purchaseOrderItemListCtrl(common, datacontext, $scope, $routeParams, NgTableParams, $filter) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        $scope.po_id = $routeParams.poid;
        vm.po_items = [];
        vm.title = 'PO List View';

        //default criteria that will be sent to the server
        vm.startSearch = 1;
        vm.query = {
            queryType:'array-count',
            search : '',
            po_id : $scope.po_id,
            pageNumber: 1,
            sortDir: 'asc',
            sortedBy: 'id',
            page:1,
            limit:50
        };

        /*$scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                    get_po_items();
                }
            }
        });*/

        activate();

        function activate() {
            var promises = [get_po_items()];
            common.activateController(promises, controllerId)
                .then(function () {
                });
        }

        function get_po_items() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_po_items(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        // set new data
                        vm.results = httpResult.data.data;
                        return  httpResult.data.data;
                    });
                }
            });
        }

        $scope.search = function(search, search_vendor_sku) {
            if(search.length || search_vendor_sku.length){
                vm.query.search = search;
                vm.query.search_vendor_sku = search_vendor_sku;
            }else{
                vm.query.search = "";
                vm.query.search_vendor_sku = "";
            }
            get_po_items();
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'poItemSearchCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$location', 'NgTableParams', '$filter', poItemSearchCtrl]);

    function poItemSearchCtrl(common, datacontext, $scope, $routeParams, $location, NgTableParams, $filter) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.po_id = $routeParams.poid;
        vm.products = [];
        vm.title = 'PO List View';

        //default criteria that will be sent to the server
        vm.startSearch = 1;
        vm.query = {
            queryType:"array-count",
            search : '',
            search_vendor_sku : '',
            po_id : $scope.po_id,
            pageNumber: 1,
            sortDir: 'asc',
            sortedBy: 'id',
            page:1,
            limit:20
        };

        /*$scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                    get_po_item_search();
                }
            }
        });*/

        activate();

        function activate() {
            var promises = [get_po_item_search()];
            common.activateController(promises, controllerId)
                .then(function () {
                });
        }

        function get_po_item_search() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            },{
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_po_item_search(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        // set new data
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

        $scope.search = function(search, search_vendor_sku) {
            if(search.length || search_vendor_sku.length){
                vm.query.search = search;
                vm.query.search_vendor_sku = search_vendor_sku;
            }else{
                vm.query.search = "";
                vm.query.search_vendor_sku = "";
            }
            get_po_item_search();
        };

        // Create New Product
        $scope.create_product = function () {
            // Set Vendor id
            datacontext.create_product(vm.po_id).success(function (httpResult) {
                log('product created');
                $location.path('/purchaseorders/' + vm.po_id + '/add_receive/' + vm.product_id);
            });
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'poReceiveItemCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', poReceiveItemCtrl]);

    function poReceiveItemCtrl(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;

        vm.poi_updated = 0;

        activate();

        function activate() {
            var promises = [get_po_items(),get_po_items_audit() ];
            common.activateController(promises, controllerId)
                .then(function () {
                });
        }
        console.log($scope);
        function get_po_items() {
            return datacontext.get_po_items({po_id:$scope.po_id, product_id:$scope.product_id}).then(function(httpResult) {

                if ( httpResult.data.data.length ) {
                    vm.po_item = httpResult.data.data[0];
                    if(vm.po_item.qty_received === 0){
                    	vm.po_item.qty_received = '';
                    }
                } else {
                    vm.po_item  = {
                        po_item_id:"",
                        vendor_sku: $scope.vendor_sku,
                        vendor_product_id: $scope.vendor_product_id
                    };
                }
            });
        }

        function get_po_items_audit() {
            return datacontext.get_po_items_audit({po_item_id:$scope.po_item_id}).then(function(httpResult) {
              console.log(httpResult);
              vm.po_item_audit = httpResult.data.data;
              console.log(vm.po_item_audit);
            });
        }

        // create PO Item
        $scope.create_po_item = function () {

            // add po_id
            vm.po_item.po_id = $scope.po_id;
            vm.po_item.product_id = $scope.product_id;

            datacontext.create_po_item(vm.po_item).then(function (httpResult) {
                get_po_items();
                log('po item created');
                vm.poi_updated = 1;
            });
        };

        // update PO Item
        $scope.update_po_item = function () {
            datacontext.update_po_item(vm.po_item).then(function (httpResult) {
               vm.poi_updated = 1;
           });
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'poiEditModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modal', '$modalInstance','po_item_update', poiEditModalCtrl]);

    function poiEditModalCtrl(common, datacontext, $scope, $modal, $modalInstance, po_item_update) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        console.log(po_item_update);
        // Pushes input to scope UGLY
        $scope.po_id = po_item_update.po_id;
        $scope.product_id = po_item_update.product_id;
        $scope.po_item_id = po_item_update.po_item_id;
        $scope.product_title = po_item_update.product_title;
        $scope.vendor_product_id = po_item_update.vendor_product_id;
        $scope.vendor_sku = po_item_update.vendor_sku;

        $scope.create_product_from_vendor_product= function (vendor_product_id) {

            // get vendor product data
            datacontext.get_vendor_product_list({vendor_product_id:vendor_product_id}).
                then(function (httpResult) {

                    var vp = httpResult.data.data[0];

                    // Set Product Defaults
                    var product =
                    {
                        product_name: vp.product_title,
                        vendor_product_id: vendor_product_id,
                        product_id:'',
                        manufacturer_id:vp.manufacturer_id,
                        category_id:vp.category_id,
                        height:vp.height,
                        width:vp.width,
                        msrp:vp.msrp,
                        price:vp.price,
                        upc:vp.upc,
                        weight:vp.weight
                    };

                    if ( product.product_id.length === 0) {
                        datacontext.create_product(product).then(function (httpResult) {
                            product.product_id = httpResult.data.data;
                            $scope.product_id = httpResult.data.data;

                            // add newly created product id to vendor product table
                            datacontext.update_vendor_product({
                                vendor_product_id:product.vendor_product_id,
                                product_id:product.product_id}).then(function () {
                                // update  redirect to edit po
                                $scope.po_item_update = {
                                    product_id:product.product_id,
                                    po_item_id:product.po_item_id
                                };
                            });
                        });
                    }
            });

        };

        vm.update_poi_modal = function (idx) {

            $scope.po_item_update = {
                product_id:idx.product_id,
                product_title:idx.product_title,
                po_id:$scope.po_id,
                po_item_id:idx.po_item_id,
                vendor_product_id:idx.vendor_product_id,
                vendor_sku:idx.vendor_sku,
                vendor_image:idx.vendor_image,
                vendor_id:idx.vendor_id
            };

            // merge order item w/order items
            var modalInstance = $modal.open({
                templateUrl: '/app/purchaseorderproducts/partials/update_poi_modal.html',
                controller:"poiEditModalCtrl",
                resolve: {
                    po_item_update: function () {
                        return $scope.po_item_update;
                    }
                }
            }).result.then(function(result){
                    // reload
                });
        };

        $scope.match_vendor_product_modal= function (idx) {

            // set data
            var data = {
                product_id:idx.product_id,
                vendor_product_id:po_item_update.vendor_product_id
            };

            // update vendor product
            datacontext.update_vendor_product(data).then(function (httpResult) {

                $modalInstance.close();

                $scope.po_item_update = {
                    product_id:idx.product_id,
                    product_title:idx.product_title,
                    po_id:$scope.po_id,
                    po_item_id:idx.po_item_id,
                    vendor_product_id:po_item_update.vendor_product_id,
                    vendor_sku:idx.vendor_sku
                };

                // redirect to edit po
                vm.update_poi_modal($scope.po_item_update);
            });
        };

        $scope.ok = function () {
            // action after clicking ok
            var formData = {};
            // add new order ship tracking entry to order item

            $modalInstance.close($scope.fulfill);
            //return datacontext.update_order_status(order[0].order_id, 2).then(function(httpResult) {
            //    $modalInstance.close($scope.fulfillment_order);
            //});
        };

        $scope.cancel = function () {
            // close modal
           $modalInstance.close('cancel');
        };
    }
})();


(function() {
    'use strict';
    var controllerId = 'popickListCntl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', popickListCntl]);

    function popickListCntl(common, datacontext, $scope, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.picklist = [];
        vm.title = 'Pick List';
        vm.slip_id = $routeParams.pid;
        vm.alerts = [];
        vm.pick_items_left = 0;
        vm.submitted = false;
        vm.btn_step = 'pick';

        activate();

        function activate() {
            var promises = [get_pick_list()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Pick List View');
                });
        }

        function get_pick_list() {
            return datacontext.get_pick_list(vm.slip_id).then(function(httpResult) {
                vm.picklist = httpResult.data.data;
                vm.pick_items_left = vm.picklist.length;
            });
        }

        vm.submit_pick_update = function(idx) {

            // TODO: disable button to keep from
            // getting hit more than once
            vm.submitted = true;

            // check if form valid submitted blank qty packed
            if ($scope.pickForm.$invalid === false) {
                // Get current object
                //var item_picked = $scope.picklist[idx];
                // Pack Form ok we can go ahead now and update
                // Check if picker is short packing

                if (vm.btn_step === 'pick' && vm.picklist[idx].qty_ordered !== Number(vm.picklist[idx].qty_picked)) {
                    vm.btn_step = 'CONFIRM';
                    vm.submitted = false;
                    vm.alerts = [{
                        type: 'warning_panel',
                        msg: vm.picklist[idx].qty_picked + ' picked' + ' of ' + vm.picklist[idx].qty_ordered + ' ordered' + " location: " + vm.picklist[idx].location_name
                    }];
                } else {
                    // Check if updating last one
                    if (vm.picklist.length === 1) {
                        vm.picklist[idx].is_picked = 1;
                    }
                    // Update Pick Item
                    $scope.update_pick_item(idx);
                    vm.submitted = false;
                }
            }else{log('invalid form submitted')}
        };

        $scope.update_pick_item = function(idx) {
            datacontext.update_pick_list(vm.picklist[idx]).success(function(httpResult) {
                // Returns list of Pick / Pack slips
                if (httpResult.success === true) {
                    // Reset: clear submission for next item
                    vm.btn_step = 'pick';
                    vm.submitted = 'false';

                    // Alert User Item Packed
                    vm.alerts = [{
                        type: "success_panel",
                        msg: vm.picklist[idx].qty_picked + ' x ' + vm.picklist[idx].product_title + ' Picked'
                    }];
                    // Reduce Pick Count & Packed item
                    vm.pick_items_left = vm.pick_items_left - 1;
                    vm.picklist.splice(idx, 1);


                } else {
                    //$scope.errors.push(result.error);
                    $scope.alerts = [{
                        type: 'error_panel',
                        msg: 'error' + item_picked
                    }];
                }
            }).error(function(data, status) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                log('error with update');
            });
        };
    }
})();


(function() {
    'use strict';
    var controllerId = 'poItemCreateCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', poItemCreateCtrl]);

    function poItemCreateCtrl(common, datacontext, $scope, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.title = 'PO Item Create';

        // Set Product Defaults
        $scope.product =
        {
            vendor_sku:'',
            vendor_id:'',
            product_id:"",
            height:"",
            msrp:0,
            weight:0
        };

        activate();

        function activate() {
            var promises = [get_product_status(),get_manufacturers()];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Product Detail View');
                });
        }

        function get_product_status() {
            return datacontext.get_product_status(vm.product_id).then(function(httpResult) {
                vm.product_status = httpResult.data.data;
            });
        }

        function get_manufacturers() {
            return datacontext.get_manufacturers().then(function (httpResult) {
                vm.items = httpResult.data;
            });
        }

        // Updates Products
        $scope.create_product = function() {

            console.log($scope.cProductForm.$invalid);

            if ($scope.cProductForm.$invalid === false) {
                console.log($scope.product);

                datacontext.create_product($scope.product).then(function(response) {
                    vm.product_status = response;
                    vm.isCreated = true;

                });
            } else{
                vm.message_text = 'Missing Information';
            }
        };
    }
})();
